import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, ErrorHandler, inject, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { ThemeDetection } from '@ionic-native/theme-detection/ngx';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AFS_THEME_DARK, provideAFS } from '@afs-ng/core'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DeviceDetectorService } from 'ngx-device-detector';
import { CookieService } from 'ngx-cookie-service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NavigationComponent } from './_interfaces/navigation/navigation.component';
import { JwtInterceptor } from './_interceptor/jwt.interceptor';
import { AddTicketPageModule } from './_template/popup-content/add-ticket/add-ticket.module';
import { KundenPopoverPageModule } from './_template/popover/kunden-popover/kunden-popover.module';
import { TicketArtSelectPageModule } from './_template/ticket-more/ticket-detail-allgemein/ticket-art-select/ticket-art-select.module';
import { PopoverPageModule } from './_template/popover/popover.module';
import { AnsprechpartnerPopoverPageModule } from './_template/popover/ansprechpartner-popover/ansprechpartner-popover.module';
import { TimeOverviewBasePageModule } from './_template/time-overview/time-overview-base/time-overview-base.module';
import { AddTimePageModule } from './_template/ticket-more/ticket-detail-zeiten/add-time/add-time.module';
import { SplashComponent } from './_template/splash/splash.component';
import { SetupPageModule } from './_pages/setup/setup.module';
import { ReleaseLicensePageModule } from './_template/release-license/release-license.module';
import { AddContactPersonPageModule } from './_template/crm-detail/add-contact-person/add-contact-person.module';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { ArtPopoverPageModule } from './_template/popover/art-popover/art-popover.module';
import { ComponentsModule } from './components/components.module';
import { HotkeyModule } from 'angular2-hotkeys';
import { Zeroconf } from '@awesome-cordova-plugins/zeroconf/ngx';
import { MarkdownModule } from 'ngx-markdown'; 


import { QuillModule } from "ngx-quill";
import { SignPageModule } from './_pages/sign/sign.module';
import { SignPreviewPageModule } from './_pages/sign/sign-preview/sign-preview.module';
import { MultiselectPageModule } from './_template/popover/multiselect/multiselect.module';
import { AppAvailability } from '@awesome-cordova-plugins/app-availability/ngx';
import { HotkeyCheatsModule } from './_interfaces/navigation/hotkeys/hotkeys.module';
import * as SentryAngular from "@sentry/angular";

import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { AfsConfirmComponent } from "@afs-ng/overlays";

registerLocaleData(localeDe);


@NgModule({ declarations: [
        AppComponent,
        NavigationComponent,
        SplashComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
    IonicModule.forRoot(),
    HotkeyModule.forRoot(),
    QuillModule.forRoot(),
    MarkdownModule.forRoot(),
    AppRoutingModule,
    AddTicketPageModule,
    KundenPopoverPageModule,
    TicketArtSelectPageModule,
    PopoverPageModule,
    MultiselectPageModule,
    AnsprechpartnerPopoverPageModule,
    TimeOverviewBasePageModule,
    SetupPageModule,
    ArtPopoverPageModule,
    AddTimePageModule,
    SignPageModule,
    SignPreviewPageModule,
    HotkeyCheatsModule,
    ComponentsModule,
    ReleaseLicensePageModule,
    AddContactPersonPageModule, AfsConfirmComponent], 
        providers: [
        SplashScreen,
        StatusBar,
        NativeStorage,
        ThemeDetection,
        CookieService,
        Zeroconf,
        AppAvailability,
        AndroidPermissions,
        DeviceDetectorService,
        { provide: ErrorHandler, useValue: SentryAngular.createErrorHandler() },
        { provide: APP_INITIALIZER, useFactory: () => () => { }, deps: [SentryAngular.TraceService], multi: true },
        { provide: SentryAngular.TraceService, deps: [Router] },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'de' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
        provideHttpClient(withInterceptorsFromDi()),
        provideAFS({
            theme: {
                preset: AFS_THEME_DARK,
                override: {
                    properties: {
                        datepicker: {
                            height: "30px"
                        }
                    }
                }
            }
        })
    ] })
export class AppModule {}